import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class OpenSubStationDropdownAction extends BaseAction<void, {dropdownName: string, openDropdowns: any}> {

    override async run(): Promise<void | null> {
        try {
            const { dropdownName, openDropdowns } = this.params!;
            updateRecoilState("subStationDropdownAtom", {
                ...openDropdowns,
                [dropdownName]: !openDropdowns[dropdownName],
              })
        } catch (error) {
            console.error("Error in OpenSubStationDropdownAction:", error);
        }
    }
}

// Create a singleton instance
export const openSubStationDropdownAction = new OpenSubStationDropdownAction(); 